// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ni-1";
export var stateContainer = "_ni-0";